import { useEffect, useId, useState } from 'react';
import { accountsEnabled, requestWithAdultRefresh } from './AdultAuthPanel';

const WORLDS = { suma: 'Suma', resta: 'Resta', mult: 'Multiplicación', division: 'División' };

export default function FamilyProgressSection({ familyId, student }) {
  const id = useId(), binding = `${familyId}:${student.student_id}`;
  const [revision, setRevision] = useState(0), [data, setData] = useState(null);
  useEffect(() => {
    if (!accountsEnabled || !revision) return undefined;
    let current = true;
    setData({ binding, state: 'loading' });
    requestWithAdultRefresh(`/families/${familyId}/students/${student.student_id}/progress`)
      .then(result => {
        if (result?.student_id !== student.student_id || !Number.isInteger(result.revision) || result.revision < 0 ||
            !Number.isInteger(result.runs) || result.runs < 0 || !Array.isArray(result.worlds) || result.worlds.length !== 4 ||
            new Set(result.worlds.map(world => world.planet_id)).size !== 4 || result.worlds.some(world =>
              !Object.prototype.hasOwnProperty.call(WORLDS, world.planet_id) || !Number.isInteger(world.mission_count) || world.mission_count < 1 ||
              !Number.isInteger(world.completed_missions) || world.completed_missions < 0 || world.completed_missions > world.mission_count)) throw new Error('Invalid progress');
        if (current) setData({ binding, state: 'ready', result });
      }).catch(() => { if (current) setData({ binding, state: 'unavailable' }); });
    return () => { current = false; };
  }, [binding, familyId, student.student_id, revision]);
  if (!accountsEnabled) return null;
  const current = data?.binding === binding ? data : { state: 'idle' };
  return <section aria-labelledby={`${id}-title`}>
    <h4 id={`${id}-title`}>Progreso de {student.alias}</h4>
    {current.state === 'loading' && <p role="status">Consultando su progreso…</p>}
    {current.state === 'unavailable' && <p role="alert">Progreso no disponible. Revisa tu sesión y vuelve a intentarlo.</p>}
    {current.state === 'ready' && <div aria-live="polite">
      <p>Aventuras registradas: {current.result.runs}</p>
      <ul>{current.result.worlds.map(world => <li key={world.planet_id}>
        {WORLDS[world.planet_id]}: {world.completed_missions} de {world.mission_count} misiones dominadas
      </li>)}</ul>
    </div>}
    <button type="button" disabled={current.state === 'loading'} onClick={() => setRevision(value => value + 1)}>
      {current.state === 'idle' ? 'Consultar progreso' : current.state === 'unavailable' ? 'Reintentar progreso' : 'Actualizar progreso'}
    </button>
  </section>;
}
